//@ts-nocheck
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

import { useCreateSkill } from '@/hooks/api/useSkills';
import { SimpleForm } from '@/components/SimpleForm';
import { FormInput } from '@/components/shared/FormInput';
import { FormTextarea } from '@/components/shared/FormTextArea';
import { useEffect } from 'react';
import { useDialog } from '@/providers/DialogProvider';
import { useDialogManager } from '@/hooks/useDialogManager';

export const CreateSkillForm = () => {
  const { closeDialog } = useDialogManager();
  const { createSkill, isCreating } = useCreateSkill();
  const { setIsDirty } = useDialog();

  const methods = useForm();
  const {
    reset,
    formState: { isDirty },
  } = methods;

  // useEffect(() => {
  //   setIsDirty(isDirty);
  // }, [isDirty, setIsDirty]);

  const onSubmit = (formData) => {
    createSkill(formData, {
      onSuccess: () => {
        toast.success('New skill created!');
        reset();
        closeDialog();
      },
      onError: () => toast.error('Could not create skill.'),
    });
  };

  return (
    <SimpleForm
      methods={methods}
      onSubmit={onSubmit}
      submitText="Save Changes"
      onCancel={closeDialog}
      className="space-y-6"
    >
      <FormInput
        name="name"
        label="Skill Name"
        type="text"
        rules={{ required: 'Skill name is required' }}
      />
      <FormTextarea
        name="description"
        label="Description"
        placeholder="Describe the issue or outage..."
        rows={5}
      />
    </SimpleForm>
  );
};
